import React from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Text from "@src/sharedComponents/Typography/Text";

import sharedStyles from "./shared.module.css";
import styles from "./TransitionHubSpotCard.module.css";

export interface HubSpotLink {
  title: string;
  url: string;
}

interface TransitionHubSpotCardProps {
  title?: string;
  links: HubSpotLink[];
}

const TransitionHubSpotCard: React.FC<TransitionHubSpotCardProps> = ({
  title = "HubSpot",
  links,
}) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {/* Title row */}
      <div className={styles.titleRow}>
        <Text variant="title3" color="text">
          {title}
        </Text>
      </div>

      {/* Divider below title */}
      <div className={styles.divider} />

      {/* Link rows without dividers */}
      {links.map((link) => (
        <div key={link.url} className={styles.linkRow}>
          <div className={styles.leftContent}>
            <Text variant="body" color="text">
              {link.title}
            </Text>
          </div>
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={sharedStyles.openLink}
          >
            <Text variant="body" color="text">
              Open
            </Text>
            <OpenInNewIcon className={styles.icon} />
          </a>
        </div>
      ))}
    </div>
  );
};

export default TransitionHubSpotCard;
